import { Device } from "./Device";
import { parseDevice } from "./DeviceParser";
import { BaseShipment } from "./BaseShipment";
import { IAnyObject } from "../interfaces";

export class Shipment extends BaseShipment {
	/**
 	* @deprecated The variable should not be used
 	*/
	public devices: Device[];

	public constructor(data: IAnyObject) {
		super(data);
		if (!data) {
			return;
		}

		if (data.devices) {
			this.devices = (data.devices as IAnyObject[]).map(parseDevice).filter(_ => _ !== null) as Device[];
		}
	}

	public toString(): string {
		return "";
	}

	public static parse(serialized: string): Shipment {
		return new Shipment(JSON.parse(serialized));
	}

	public static stringify(instance: Shipment): string {
		return JSON.stringify(instance);
	}

	public formatErrorDeviceName(device: string): string {
		const prefix = (() => {
			switch ((this.company || "").toUpperCase()) {
				case "ENVIROTAINER": {
					return "ENV";
				}
				case "PT300D":
				case "PT300": {
					return "";
				}
				default:
					return "";
			}
		})();

		return device.startsWith(prefix + "-") ? device.substring(prefix.length + 1) : device;
	}
}
